/**
 * journey-ux/Pill.jsx — semantic status pill (Phase 1 primitive)
 *
 * Part of TREATMENT-JOURNEY-IMPLEMENTATION-001 Phase 1 foundation.
 * Renders a compact pill chip with a semantic tone. Replaces the
 * card+badge combo for dense table cells.
 *
 * Tones map directly to the design-spec from COORDINATOR-GRID-UX-001:
 *   emerald = Done / On track / Healing / Cleared
 *   amber   = In progress / Awaiting / Caution
 *   rose    = Blocked / Outstanding / Overdue
 *   violet  = Surgery day / Major event
 *   sky     = Identifier / Step / Day
 *   slate   = Neutral / Inactive / Future
 */
import React from 'react';

const TONES = {
  slate: 'bg-slate-100 text-slate-700',
  emerald: 'bg-emerald-100 text-emerald-700',
  amber: 'bg-amber-100 text-amber-800',
  rose: 'bg-rose-100 text-rose-700',
  sky: 'bg-sky-100 text-sky-700',
  violet: 'bg-violet-100 text-violet-700',
  indigo: 'bg-indigo-100 text-indigo-700',
  stone: 'bg-stone-100 text-stone-700',
};

export const Pill = ({ tone = 'slate', children, testId, className = '' }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10.5px] font-semibold leading-[14px] ${TONES[tone] || TONES.slate} ${className}`}
  >
    {children}
  </span>
);

export default Pill;
